import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";


type Props = {
    onActionEdit: (idNovosNegociosArquivo: number | null, openState: boolean) => void,
    onActionDelete: (idNovosNegociosArquivo: number | null, openState: boolean) => void,
    onActionDownload: (idNovosNegociosArquivo: number, imageName: string) => void,
}

export const GenerateNovosNegociosArquivosColumns = ({
    onActionEdit,
    onActionDelete,
    onActionDownload,

}: Props): GridColDef[] => {

    return [

        {
            field: "descricao",
            filterable: false,
            headerName: "Descrição",
            flex: 1,
            minWidth: 200,
            sortable: false,
        },
        {
            field: "nome",
            filterable: false,
            headerName: "Arquivo",
            flex: 1,
            minWidth: 60,
            sortable: false,
            valueGetter: (_, row) => [row['nome'], row['idNovosNegociosArquivo']],
            renderCell: ({ value: [nome, id] }) => {
                return (
                    <Button
                        onMouseDown={() => onActionDownload(id, nome)}
                        sx={{
                            fontSize: 11,
                            paddingX: '.4rem',
                            paddingY: 0,
                            background: '#e6e6e6',
                            borderLeft: '.3rem solid #4b8df8',
                            borderRadius: 0,
                            color: 'black',
                            fontWeight: 'normal',
                        }}>
                        {nome}
                    </Button>
                );
            }
        },
        {
            field: 'idNovosNegociosArquivo',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            minWidth: 150,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">

                        <IconButton onClick={() => onActionEdit(params.value, true)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        <IconButton onClick={() => onActionDelete(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>

                    </div>
                );
            }
        }

    ];

}